import forEach from 'lodash/forEach';

/**
 * Helper function to lowercase the first letter of a string
 * @param {String} str String to lowercase the first letter of
 * @return {String}
 */
function lowercaseFirstLetter(str) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

/**
 * Remove prefix and lowercase the first letter (redactorMinHeight becomes minHeight)
 * @param {String} str
 * @return {String}
 */
function transformToOption(str, prefix) {
  const replaceRegex = new RegExp(`^${prefix}`);
  return lowercaseFirstLetter(str.replace(replaceRegex, ''));
}

/**
 * Loop through all data attributes and rewrite them to options without prefix
 * @param {Object} props Data attributes set on the textarea element
 * @return {Object} Options
 */
export default (props, prefix) => {
  const newProps = {};

  // Redactor options should begin with redactor-
  const regex = new RegExp(`^${prefix}`);

  // Loop through all properties
  forEach(props, (propVal, propKey) => {
    // Check if the data attribute is starting with redactor
    if (regex.test(propKey)) {
      const newPropKey = transformToOption(propKey, prefix);

      // Save the option
      newProps[newPropKey] = propVal;
    }
  });

  // Return Redactor options
  return newProps;
};
